import API from "./api";

export const GetGeneralInfo = (configUrl: string, referralId: number) => {
  return API.get(`${configUrl}api/authorization/AuthorizationGeneralInfo?referralId=${referralId}`);
};

export const GetDocumentList = (baseUrl: string, referralId: number, type: number) => 
  API.get(
    `${baseUrl}api/authorization/documents/${referralId}/${type}`
  );

export const GetDocumentDownload = (
  baseUrl: string,
  blobId: number,
  type?: string
) => API.get(`${baseUrl}api/authorization/download/${blobId}`, type);

export const GetRequestDetails = (configUrl: string, referralId: number  ) => {
  return API.get(`${configUrl}api/authorization/authorizationRequestDetails?referralId=${referralId}`,true );
};

export const GetNotesList = (configUrl: string, referralId: number) => {
  return API.get(`${configUrl}api/notes/notesList?referralId=${referralId}`, true);
};

export const GetNoteView = (configUrl: string, referralNoteId: number) => {
  return API.get(`${configUrl}api/notes/noteEntry?referralNoteId=${referralNoteId}`, true);
};

export const GetNotesViewByDisciplineNoteId = (configUrl: string, disciplineNoteId: number) => {
  return API.get(`${configUrl}api/notes/noteEntry?disciplineNoteId=${disciplineNoteId}`, true);
}